import { NativeAssetDecimals, NativeAssetId, NativeAssetTicker } from "../constants";
export function isNative(ai) {
    return ai.id === NativeAssetId;
}
export const NativeAssetInfo = {
    id: NativeAssetId,
    name: NativeAssetTicker,
    decimals: NativeAssetDecimals
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZXRJbmZvLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL2Fzc2V0SW5mby50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUMsbUJBQW1CLEVBQUUsYUFBYSxFQUFFLGlCQUFpQixFQUFDLE1BQU0sY0FBYyxDQUFBO0FBVWxGLE1BQU0sVUFBVSxRQUFRLENBQUMsRUFBYTtJQUNwQyxPQUFPLEVBQUUsQ0FBQyxFQUFFLEtBQUssYUFBYSxDQUFBO0FBQ2hDLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQWM7SUFDeEMsRUFBRSxFQUFFLGFBQWE7SUFDakIsSUFBSSxFQUFFLGlCQUFpQjtJQUN2QixRQUFRLEVBQUUsbUJBQW1CO0NBQzlCLENBQUEifQ==